import loadScript from './loadscript';

let installed = false;

export const install = (params, cb) => {
  window.NTKF_PARAM = params;
  if (installed) {
    cb && cb();
    return;
  }
  loadScript('https://dl.ntalker.com/js/xn6/ntkfstat.js?siteid=kf_9336', () => {
    installed = true;
    cb && cb();
  });
};

export const openChat = (id) => {
  window.NTKF.im_openInPageChat(id);
};

const openDirective = {
  bind (el, binding, vnode) {
    const id = binding.value;
    // const params = binding.
    el.addEventListener('click', () => {
      const vm = vnode.context;
      console.log(vm);
      const expr = el.getAttribute('data-ntalk-params');
      let params = expr;
      if (expr in vm) {
        params = vm[expr];
      }
      install(params, () => {
        openChat(id);
      });
    });
  }
};

export default openDirective;



// WEBPACK FOOTER //
// ./src/helper/ntalker.js